import * as XLSX from "xlsx";

/**
 * sheets: Array<{
 *   name: string,
 *   aoa: any[][],
 *   percentCols?: number[],
 *   autoWidth?: boolean
 * }>
 */
export function makeWorkbook(sheets) {
  const wb = XLSX.utils.book_new();

  const autoWidth = (aoa) =>
    (aoa[0] || []).map((_, c) => {
      const maxLen = aoa.reduce((acc, row) => {
        const cell = row?.[c] == null ? "" : String(row[c]);
        return Math.max(acc, cell.length);
      }, 0);
      return { wch: Math.min(Math.max(10, maxLen + 2), 60) };
    });

  sheets.forEach(({ name, aoa, percentCols = [], autoWidth: aw = true }) => {
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    if (aw) ws["!cols"] = autoWidth(aoa);

    // format percent columns
    for (let r = 1; r < aoa.length; r++) {
      percentCols.forEach((c) => {
        const ref = XLSX.utils.encode_cell({ r, c });
        if (ws[ref]) ws[ref].z = "0.0%";
      });
    }

    XLSX.utils.book_append_sheet(wb, ws, name);
  });

  return wb;
}

export function workbookToBlob(wb) {
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  return new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
